module.exports = __webpack_public_path__ + "img/playstore.c307059b.png";